module.exports = __webpack_public_path__ + "static/unbanked-33e3b24a10636be3bda7dd46e84e2874.svg";